import Header from "./components/Header";
import Carousel from "./components/Carousel";
import CarouselMain from "./components/CarouselMain";
import Call from "./components/Call";
import PorqueElegirnos from "./components/PorqueElegirnos";
import Services from "./components/Services";
import Footer from "./components/Footer";
import ImgStart from "./components/ImgStart";
import Formulario from "./components/Formulario"
import CasosExito from "./components/CasosExito";
import Promo from "./components/Promo"
import Section1 from "./components/Section1"
import Bot from "./components/Bot"

function App() {
  return (
    <div>
      <Header />
      <Promo/>
      <Section1 />
      <Bot/>
      <CarouselMain />
      <ImgStart />
      <Carousel />
      <Call />
      <PorqueElegirnos />
      <Services />
      <CasosExito/>
      <Formulario/>
      <Footer />
    </div>
  );
}

export default App;
